import {
    getAxiosFulfilledState,
    getPendingState,
    getRejectedState,
    getSettingsState,
    resetState,
} from '../../helpers/reducerHelper'
import { IReduxAction } from '../index'
import { DataPromise, getDataEmptyState } from '../../context/AxiosContext'
import { InvoiceAction, InvoiceOverviewDto, InvoiceStatus, MetaDataDto } from '../../config/finance/invoiceConfig'
import { ActionType } from 'redux-promise-middleware'
import { DateTime } from 'luxon'
import { formatIsoDate } from '../../helpers/dateHelper'
import { InvoiceListSettings } from '../../components/List/Invoice/InvoiceList'
import { TimeAction } from '../../config/registration/timeConfig'

export type State = {
    overview: DataPromise<InvoiceOverviewDto[], InvoiceListSettings>
    meta: DataPromise<MetaDataDto>
}

export const defaultState: State = {
    overview: getDataEmptyState<InvoiceOverviewDto[], InvoiceListSettings>({
        statuses: [InvoiceStatus.Draft, InvoiceStatus.Final, InvoiceStatus.Settled, InvoiceStatus.Credited],
        from: DateTime.local().minus({ months: 3 }).toISODate(),
        to: formatIsoDate(new Date()),
        hasTransaction: null,
        query: undefined,
        minQueryLength: 3,
        matchColumns: ['number', 'file'],
    }),
    meta: getDataEmptyState<MetaDataDto>(),
}

export default function reducer(state: State = defaultState, action: IReduxAction): State {
    switch (action.type) {
        case InvoiceAction.OverviewSettings: {
            return getSettingsState(state, action, 'overview')
        }
        case `${InvoiceAction.GetOverview}_${ActionType.Pending}`: {
            return getPendingState(state, 'overview')
        }
        case `${InvoiceAction.GetOverview}_${ActionType.Rejected}`: {
            return getRejectedState(state, action, 'overview')
        }
        case `${InvoiceAction.GetOverview}_${ActionType.Fulfilled}`: {
            return getAxiosFulfilledState(state, action, 'overview')
        }
        case InvoiceAction.ResetOverview: {
            return resetState(state, { overview: null })
        }
        case `${InvoiceAction.GetMetaData}_${ActionType.Pending}`: {
            return getPendingState(state, 'meta')
        }
        case `${InvoiceAction.GetMetaData}_${ActionType.Rejected}`: {
            return getRejectedState(state, action, 'meta')
        }
        case `${InvoiceAction.GetMetaData}_${ActionType.Fulfilled}`: {
            return getAxiosFulfilledState(state, action, 'meta')
        }
        case `${TimeAction.Update}_${ActionType.Fulfilled}`: {
            return resetState(state, { meta: state.meta.data })
        }
        case InvoiceAction.ResetMetaData: {
            return resetState(state, { meta: null })
        }
    }
    return state
}
